import { Service } from "../Service";

class AccountOdata extends Service {
    constructor(path) {
        super('/Accounts', path); // initial prefix
    }
}
export { AccountOdata };